<template>
  <v-container>
    <v-row class="pb-2">
      <v-col cols="3">
        <v-text-field
            hide-details="auto"
            outlined
            dense
            clearable
            v-model="filter['plant_name']"
            label="発電所名"
            v-on:keyup.enter="handle"
        ></v-text-field>
      </v-col>
      <v-col cols="3">
        <v-text-field
            hide-details="auto"
            outlined
            dense
            clearable
            v-model="filter['plant_address']"
            label="住所"
            v-on:keyup.enter="handle"
        ></v-text-field>
      </v-col>
      <v-col cols="2">
        <v-select
            label="利用区分"
            hide-details="auto"
            :items="useTypeItems"
            dense
            outlined
            v-model="filter['use_type']"
        ></v-select>
      </v-col>
      <v-col cols="2">
        <v-select
          label="用途"
          hide-details="auto"
          :items="useTypes"
          dense
          outlined
          v-model="filter['type']"
        ></v-select>
      </v-col>
      <v-col cols="2">
        <v-btn color="primary" height="40" block @click="searchPlant">
          <v-icon left>mdi-magnify-plus</v-icon>
          検索
        </v-btn>
      </v-col>
    </v-row>
    <v-data-table
        dense
        hide-default-footer
        :headers="tableHeaders"
        :items="plants"
        :page.sync="filter.page"
        :items-per-page="filter.per_page"
        :server-items-length="totalPlants"
        :loading="loading"
        loading-text="ローディング..."
        no-data-text="該当データがありません。"
        class="elevation-1"
        @click:row="(plant) => {
          viewDroneDeploy(plant)
      }" 

        
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>
            <b>発電所一覧</b>
            <span>（{{ totalPlants }} 件）</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <div class="text-right">
            <v-pagination
                v-if="totalPlants > 0"
                v-model="filter.page"
                :length="totalPlants == 0 ? 0 : Math.ceil(totalPlants/10)"
                total-visible="7"
                @input="changePage"
            ></v-pagination>
          </div>
          <v-spacer></v-spacer>
          <v-btn outlined style="margin-right: 10px; padding: 0;" min-width="36" height="36" @click="changeLayout">
            <v-icon v-show="gridLayout">mdi-format-list-bulleted</v-icon>
            <v-icon v-show="!gridLayout">mdi-dots-grid</v-icon>
          </v-btn>
          <v-btn
              color="primary"
              dark
              @click="addPlantDialog"
          >
            <v-icon left>mdi-map-plus</v-icon>
            新規発電所
          </v-btn>
          <add-main-plant-dialog :afterAddName="afterAddPlantName"
                                 :plantName="filter.plant_name" @updatePlantName="updatePlantName"
                                 v-model="openAddPlantDialog" @closeDialog="closeAddPlantDialog">
          </add-main-plant-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.plant_name="{ item }">
        <v-btn
            color="primary"
            text
            @click="viewDroneDeploy(item)"
          >
            <span class="text-left">{{ item.plant_name }}</span>
        </v-btn>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-spacer></v-spacer>
        <plant-options :item="item" @showDataUpload="showDataUploadDialog" @viewFolder="viewFolderList" @show="showDetail" @edit="showPlantEditDialog"></plant-options>
      </template>
      <template v-slot:body="{items}" v-if="gridLayout">
        <v-container fluid class="pt-0">
        <v-row align="stretch">
          <v-col cols="12" sm="4" md="3" v-for="item in items" :key="item.id">
            <v-card class="mx-auto" max-width="350">
              <v-img
                  :style="item.thumbnail_color_path || item.thumbnail_thermal_path ? 'background: black' : null"
                  lazy-src="@/assets/images/no-image.png"
                  :src="item.thumbnail_color_path ? item.thumbnail_color_path : item.thumbnail_thermal_path"
                  :aspect-ratio="4 / 3"
                  @click="viewDroneDeploy(item)"
              ></v-img>
              <v-card-title>
                <a style="color: #1976D2; max-width: calc(100% - 44px)" @click="viewDroneDeploy(item)" class="text-truncate">{{item.plant_name}}</a>
                <v-spacer></v-spacer>
                <plant-options :item="item" @showDataUpload="showDataUploadDialog" @viewFolder="viewFolderList" @show="showDetail" @edit="showPlantEditDialog"></plant-options>
              </v-card-title>
              <v-card-text style="min-height: 50px">
                <div class="caption">
                  {{item.plant_id}}
                </div>
                <v-tooltip bottom max-width="350">
                  <template v-slot:activator="{ on, attrs }">
                    <div class="caption text-truncate" v-bind="attrs" v-on="on">{{item.plant_address}}</div>
                  </template>
                  <div class="caption">{{item.plant_address}}</div>
                </v-tooltip>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        </v-container>
      </template>
    </v-data-table>
    <data-upload-dialog
      v-model="uploadDataDialog"
      :plantId="selectedPlantId"
    ></data-upload-dialog>
    <plant-detail-dialog v-model="plantDetailDialog" :plant="plantDetail"></plant-detail-dialog>
    <plant-edit-dialog v-model="plantEditDialog" :item="editPlant" v-if="plantEditDialog"></plant-edit-dialog>
  </v-container>
</template>

<script>
import {store} from "@/store";
import AddMainPlantDialog from "@/components/dialog/AddMainPlantDialog";
import DataUploadDialog from "./dialog/DataUploadDialog";
import PlantDetailDialog from "@/components/dialog/PlantDetailDialog";
import PlantActionOptions from "@/components/common/PlantActionOptions";
import PlantEditDialog from "@/components/dialog/PlantEditDialog";

export default {
  name: "MainPlant",

  components: {
    'add-main-plant-dialog': AddMainPlantDialog,
    "data-upload-dialog": DataUploadDialog,
    'plant-detail-dialog': PlantDetailDialog,
    'plant-options': PlantActionOptions,
    'plant-edit-dialog': PlantEditDialog,
  },

  data: () => ({
    useTypeItems: [
      {text: '全て', value: 'all'},
      {text: '工事', value: '1construction'},
      {text: '査定', value: '2assessment'},
      {text: 'メンテ', value: '3maintenance'},
      {text: 'ドローン', value: '4drone'},
    ],
    //search by "用途"
    useTypes: [
      {text: '全て', value: 'all'},
      { text: "マップ・モデル", value: " map" },
      { text: "図面", value: "diagram" },
      { text: " 360画像", value: "360image" },
      { text: "動画", value: "video" },
    ],
    filter: {
      'use_type': store.state.plant_search_filter.useType,
      'type': store.state.plant_search_filter.type,
      'plant_name': store.state.plant_search_filter.plant_name,
      'plant_address': store.state.plant_search_filter.plant_address,
      page: parseInt(store.state.plant_search_filter.page),
      per_page: 10,
    },
    loading: true,
    tableHeaders: [],
    totalPlants: 0,
    plants: [],
    openAddPlantDialog: false,
    uploadDataDialog: false,
    selectedPlantId: null,
    plantDetailDialog: false,
    plantDetail: null,
    gridLayout: store.state.plantListViewMode === 'grid',
    plantEditDialog: false,
    editPlant: null,
  }),

  methods: {
    resetData() {
      this.loading = true;
      this.totalPlants = 0;
      this.plants = [];
    },
    getMainPlants() {
      this.resetData();
      if (this.filter.plant_name){
        this.filter.plant_name = this.filter.plant_name.trim().replaceAll("\\p{Z}", "");
      }
      if (this.filter.plant_address){
        this.filter.plant_address = this.filter.plant_address.trim().replaceAll("\\p{Z}", "");
      }
      this.axios
          .post("/api/main-plants", this.filter)
          .then((response) => {
            this.loading = false;
            this.plants = response.data;
            this.totalPlants = parseInt(response.headers["x-total"]);
          });
    },
    changePage() {
      this.getMainPlants();
      store.updatePlantSearchFilter(this.filter);
    },
    searchPlant() {
      this.filter.page = 1;
      this.getMainPlants();
      store.updatePlantSearchFilter(this.filter);
      
    },
    // viewPlant(plant) {
    //   this.$router.push('/plant/' + plant.id + '/block');
    // },
    afterAddPlantName() {
      this.filter.page = 1;
      this.getMainPlants();
    },
    updatePlantName(plant_name) {
      this.filter.plant_name = plant_name;
      this.filter.use_type = 'all';
      store.updateUseType(this.filter.use_type);
    },
    addPlantDialog() {
      this.openAddPlantDialog = true;
    },
    closeAddPlantDialog(v) {
      this.openAddPlantDialog = v;
    },
    showDataUploadDialog(plant) {
      this.selectedPlantId = plant.id;
      this.uploadDataDialog = true;
    },
    viewFolderList(plant) {
      this.$router.push('/plant/' + plant.id + '/folder');
    },
    viewDroneDeploy(plant){
      this.axios
        .get("/api/main-plant/first-folder/"+ plant.id )
        .then((response) => {
          this.$router.push('/map/' + response.data.id);
        })
        .catch(()=> {
          store.showErrorDialog('マップデータはありません。');
        });
    },
    showDetail(plant){
      this.axios
          .get('/api/plant/' + plant.id)
          .then((response) => {
            this.plantDetailDialog = true;
            this.plantDetail = response.data;
            this.plantDetail.plant = plant;
          });
    },
    changeLayout(){
      this.gridLayout = !this.gridLayout;
      this.tableHeaders = []
    },
    resetTableHeaders(){
      if (this.gridLayout){
        this.tableHeaders = [];
      }
      else {
        this.tableHeaders = [
          {
            text: "経産省ID",
            sortable: false,
            value: "plant_id",
          },
          {
            text: "発電所名",
            sortable: false,
            value: "plant_name",
          },
          {
            text: "住所",
            sortable: false,
            value: "plant_address",
          },
          {
            text: "アクション",
            sortable: false,
            value: "actions",
            align: 'center',
          },
        ];
      }
    },
    showPlantEditDialog(plant){
      this.editPlant = plant;
      this.plantEditDialog = true;
    },
    handle(){
      this.searchPlant();
    }
  },

  created() {
    this.getMainPlants();
    this.resetTableHeaders();
  },
  watch: {
    gridLayout(gridLayout){
      if (gridLayout){
        store.updatePlantListViewMode('grid');
      }
      else{
        store.updatePlantListViewMode('list');
      }
      this.resetTableHeaders();
    }
  }
}
</script>

<style>
.elevation-1 >>> tbody tr :hover {
  cursor: pointer;
}
.v-pagination__item, .v-pagination__navigation{
  border: 1px solid gray;
  box-shadow: unset;
}
</style>
